module.exports = __webpack_public_path__ + "static/img/9.040c6a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/5/zh/9.png
// module id = iWE0
// module chunks = 0